<div *ngIf="order" class="row justify-content-center">
  <div>
    <mat-card appearance="outlined" class="mb-25 ao-card">
      <mat-card-header class="mat-mdc-card-header border-bottom">
        <div class="top d-flex align-items-center justify-content-start w-100">
          <ol class="breadcrumb mb-0 ps-0">
            <li *ngIf="vendor" class="breadcrumb-item">
              <a (click)="viewVendorOrders()">Invoices</a>
            </li>
            <li *ngIf="vendor" class="breadcrumb-item">
              <ng-container *ngIf="vendor?.images?.length; else nameBlock">
                <app-product-image
                  [image]="vendor.images[0]"
                  [uploads]="true"
                  [alt]="vendor.name"
                  class="logo"
                ></app-product-image>
              </ng-container>
              <ng-template #nameBlock>
                {{ distributor?.name ?? vendor.name | case }}
              </ng-template>
            </li>
            <li
              *ngIf="order?.invoiceNumber"
              class="breadcrumb-item fw-semibold"
            >
              {{ order.invoiceNumber }}
            </li>
          </ol>
        </div>
      </mat-card-header>
      <!-- Return Frame{{ framesSelected ? 's' : '' }} to inventory -->
      <mat-card-content class="mat-mdc-card-content">
        <div class="mat-table">
          <table mat-table [dataSource]="dataSource" class="ao-job-table">
            <ng-container matColumnDef="invoiceMeta">
              <td
                mat-header-cell
                *matHeaderCellDef
                class="invoice-meta-cell"
                [attr.colspan]="displayedColumns.length"
              >
                <div class="invoice-meta-fields">
                  <div class="invoice-status">{{ order.status }}</div>
                  <div *ngIf="isPaid" class="invoice-paid-number">{{ order.invoiceNumber }}</div>
                  <div
                    *ngIf="!isPaid"
                    [formGroup]="orderForm"
                    class="invoice-number-field"
                    [class.invoice-number-missing]="invoiceNumberMissing"
                  >
                    <label class="invoice-number-label" for="payableInvoiceNumber">
                      Invoice Number<span class="required-asterisk">*</span>
                    </label>
                    <input
                      id="payableInvoiceNumber"
                      class="input"
                      type="text"
                      required
                      formControlName="invoiceNumber"
                      placeholder="Invoice Number"
                    />
                  </div>
                  <div *ngIf="!isPaid" [formGroup]="orderForm" class="invoice-date-field">
                    <input
                      class="input"
                      [matDatepicker]="invoiceDatePicker"
                      matInput
                      type="text"
                      formControlName="date"
                    />
                    <button
                      type="button"
                      class="invoice-date-toggle"
                      (click)="invoiceDatePicker.open()"
                      aria-label="Open calendar"
                    >
                      <mat-icon>calendar_today</mat-icon>
                    </button>
                    <mat-datepicker #invoiceDatePicker></mat-datepicker>
                  </div>
                  <span *ngIf="framesSelected" class="actions-button-sm">
                    <button [matMenuTriggerFor]="menu" class="btn modify-button">
                      <mat-icon>more_vert</mat-icon> Modify
                    </button>
                    <mat-menu #menu="matMenu">
                      <button mat-menu-item type="button" (click)="removeFrames()">RETURN TO INVENTORY</button>
                    </mat-menu>
                  </span>
                </div>
              </td>
            </ng-container>

            <!-- Frame Select -->
            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef class="ao-header-cell center">
                <span class="ao-checkbox">
                  <input type="checkbox" [checked]="allSelected" (click)="selectAllProducts($event)" class="check" />
                </span>
              </th>
              <td mat-cell *matCellDef="let element" class="ao-table-cell center">
                <span class="ao-checkbox">
                  <input type="checkbox" [checked]="selectedFrames[element.objectId]" (click)="selectProduct($event, element)" class="check" />
                </span>
              </td>
            </ng-container>

            <!-- Image Column -->
            <ng-container matColumnDef="image">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="ao-header-cell center"
              >
                Image
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                class="ao-table-cell center"
              >
                <app-product-image
                  *ngIf="element.images?.length"
                  [image]="element.images[0]"
                ></app-product-image>
              </td>
            </ng-container>

            <!-- Vendor Column -->
            <ng-container matColumnDef="name">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="ao-header-cell center"
              >
                Vendor
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                class="ao-table-cell center"
              >
                <div class="d-flex align-items-center name-info">
                  {{ element.name }}
                </div>
              </td>
            </ng-container>

            <!-- Status Column -->
            <ng-container matColumnDef="model">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="ao-header-cell center"
              >
                Model
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                class="ao-table-cell center"
              >
                {{ element.model | case: 'upper' }}
              </td>
            </ng-container>

            <!-- Date Column -->
            <ng-container matColumnDef="color">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="ao-header-cell center"
              >
                Color
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                class="ao-table-cell center"
              >
                {{ element.color }}
              </td>
            </ng-container>

            <!-- Size Column -->
            <ng-container matColumnDef="size">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="ao-header-cell center"
              >
                Size
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                class="ao-table-cell center"
              >
                {{ element.size }}
              </td>
            </ng-container>

            <!-- Type Column -->
            <ng-container matColumnDef="type">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="ao-header-cell center"
              >
                Type
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                class="ao-table-cell center"
              >
                {{ element.type }}
              </td>
            </ng-container>

            <!-- Shipping Column -->
            <ng-container matColumnDef="shipping">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="ao-header-cell center"
              >
                Shipping
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                class="ao-table-cell center"
              >
                <div class="inpt" *ngIf="!isPaid && !isCredit">
                  <app-number-input
                    classNames="product-input"
                    [value]="element.shipping"
                    [alwaysNegative]="isCredit"
                    (valueChange)="
                      updateProduct(
                        element.uniqueId,
                        $event,
                        'shipping'
                      )
                    "
                  ></app-number-input>
                </div>
                <strong *ngIf="isPaid || isCredit">{{ element.shipping | currency }}</strong>
              </td>
            </ng-container>

            <!-- Tax Column -->
            <ng-container matColumnDef="tax">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="ao-header-cell center"
              >
                Tax
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                class="ao-table-cell center"
              >
                <div class="inpt" *ngIf="!isPaid && !isCredit">
                  <app-number-input
                    classNames="product-input"
                    [value]="element.tax ?? 0"
                    [alwaysNegative]="isCredit"
                    (valueChange)="
                      updateProduct(
                        element.uniqueId,
                        $event,
                        'tax'
                      )
                    "
                  >
                  </app-number-input>
                </div>
                <strong *ngIf="isPaid || isCredit">{{ element.tax | currency }}</strong>
              </td>
            </ng-container>

            <!-- Cost Column -->
            <ng-container matColumnDef="cost">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="ao-header-cell center"
              >
                Cost
              </th>

              <td
                mat-cell
                *matCellDef="let element"
                class="ao-table-cell center"
              >
                <div class="inpt" *ngIf="!isPaid && !isCredit">
                  <app-number-input
                    classNames="product-input"
                    [value]="element.cost"
                    [alwaysNegative]="isCredit"
                    (valueChange)="
                      updateProduct(
                        element.uniqueId,
                        $event,
                        'cost'
                      )
                    "
                  ></app-number-input>
                </div>
                <strong *ngIf="isPaid || isCredit">{{ element.cost | currency }}</strong>
              </td>
            </ng-container>

            <ng-container matColumnDef="actualSpacer">
              <ng-container *ngIf="fourColumns; else threeCol">
                <td mat-footer-cell *matFooterCellDef colspan="5"></td>
              </ng-container>
              <ng-template #threeCol>
                <td mat-footer-cell *matFooterCellDef colspan="4"></td>
              </ng-template>
            </ng-container>

            <ng-container matColumnDef="actualLabel">
              <td mat-footer-cell *matFooterCellDef class="center"><strong>Subtotal</strong></td>
            </ng-container>

            <ng-container matColumnDef="actualShipping">
              <td mat-footer-cell *matFooterCellDef class="filled-light center">
                <div *ngIf="!isPaid">
                  <app-number-input classNames="product-input" [value]="order.shipping" [alwaysNegative]="isCredit"
                    (valueChange)="updateShipping($event)"></app-number-input>
                </div>
                <strong *ngIf="isPaid">{{ order.shipping | currency }}</strong>
              </td>
            </ng-container>

            <ng-container matColumnDef="actualTax">
              <td mat-footer-cell *matFooterCellDef class="filled-light center">
                <div *ngIf="!isPaid">
                  <app-number-input classNames="product-input" [value]="order.tax" [alwaysNegative]="isCredit" (valueChange)="updateTax($event)"></app-number-input>
                </div>
                <strong *ngIf="isPaid">{{ order.tax | currency }}</strong>
              </td>
            </ng-container>

            <ng-container matColumnDef="actualCost">
              <td mat-footer-cell *matFooterCellDef class="filled-light center">
                <div *ngIf="!isPaid">
                  <app-number-input classNames="product-input" [value]="order.cost" [alwaysNegative]="isCredit" (valueChange)="updateCost($event)"></app-number-input>
                </div>
                <strong *ngIf="isPaid">{{ order.cost | currency }}</strong>
              </td>
            </ng-container>

            <ng-container  matColumnDef="aspacer">
              <ng-container *ngIf="fourColumns; else fourCol3">
                <td mat-footer-cell *matFooterCellDef colspan="7"></td>
              </ng-container>
              <ng-template #fourCol3>
                <td mat-footer-cell *matFooterCellDef colspan="6"></td>
              </ng-template>
            </ng-container>

            <ng-container *ngIf="!isCredit && !isPaid" matColumnDef="paidLabel">
              <td mat-footer-cell *matFooterCellDef class="center">
                <strong>Amt. Paid</strong>
              </td>
            </ng-container>

            <ng-container *ngIf="!isCredit && !isPaid" matColumnDef="paid">
              <td mat-footer-cell *matFooterCellDef class="center">
                <div class="agg-div" *ngIf="!isPaid">
                  <app-number-input classNames="product-input" [value]="order.partialPayment" (valueChange)="updatePayment($event)"></app-number-input>
                </div>
                <strong *ngIf="isPaid">{{ order.partialPayment | currency }}</strong>
              </td>
            </ng-container>

            <ng-container matColumnDef="dspacer">
              <ng-container *ngIf="fourColumns; else fourCol6">
                <td mat-footer-cell *matFooterCellDef colspan="7"></td>
              </ng-container>
              <ng-template #fourCol6>
                <td mat-footer-cell *matFooterCellDef colspan="6"></td>
              </ng-template>
            </ng-container>

            <ng-container *ngIf="!isCredit" matColumnDef="dueLabel">
              <td mat-footer-cell *matFooterCellDef class="center">
                <strong>Amt. Due</strong>
              </td>
            </ng-container>

            <ng-container *ngIf="!isCredit" matColumnDef="due">
              <td mat-footer-cell *matFooterCellDef class="center">
                <strong>{{ order.amountDue ?? 0 | currency }}</strong>
              </td>
            </ng-container>

            <ng-container *ngIf="isCredit" matColumnDef="lossLabel">
              <td mat-footer-cell *matFooterCellDef class="center">
                <strong>Proposed Credit</strong>
              </td>
            </ng-container>

            <ng-container *ngIf="isCredit" matColumnDef="loss">
              <td mat-footer-cell *matFooterCellDef class="center agg-cell">
                <div class="agg-div">
                  <app-number-input classNames="product-input" [value]="order.proposedCredit" (valueChange)="updateProposedCredit($event)"></app-number-input>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="spacer">
              <ng-container *ngIf="fourColumns; else fourCol8">
                <td mat-footer-cell *matFooterCellDef colspan="7"></td>
              </ng-container>
              <ng-template #fourCol8>
                <td mat-footer-cell *matFooterCellDef colspan="6"></td>
              </ng-template>
            </ng-container>

            <ng-container matColumnDef="totalLabel">
              <td mat-footer-cell *matFooterCellDef class="center">
                <strong>Total</strong>
              </td>
            </ng-container>

            <ng-container matColumnDef="total">
              <td mat-footer-cell *matFooterCellDef class="center agg-cell">
                <div *ngIf="!isPaid" class="agg-div">
                  <app-number-input classNames="product-input" [value]="order.total" [showDiff]="isCredit" [isCredit]="isCredit" [alwaysNegative]="isCredit"
                    [diff]="expectedLossText" [refValue]="order.proposedCredit ?? productsTotal" (valueChange)="updateTotal($event)"></app-number-input>
                </div>
                <strong *ngIf="isPaid">{{ order.total | currency }}</strong>
              </td>
            </ng-container>



            <tr
              mat-header-row
              *matHeaderRowDef="['invoiceMeta']"
              class="ao-header-row invoice-meta"
            ></tr>
            <tr
              mat-header-row
              *matHeaderRowDef="displayedColumns"
              class="ao-header-row th"
            ></tr>
            <tr
              mat-row
              *matRowDef="let row; let odd = odd; columns: displayedColumns"
              class="ao-table-row"
              [class.ao-row-alt]="odd"
              (click)="viewProduct(row)"
            ></tr>
             <tr
                mat-footer-row
                *matFooterRowDef="['actualSpacer', 'actualLabel', 'actualShipping', 'actualTax', 'actualCost']"
                class="ao-table-row tf"
              ></tr>

              <!-- <ng-container *ngIf="isAwaitingCredit">
                                            <tr mat-footer-row *matFooterRowDef="['spacer', 'lossLabel', 'loss']" class="ao-table-row tf"></tr>
                                          </ng-container> -->
            <tr
            mat-footer-row
            *matFooterRowDef="['spacer', 'totalLabel', 'total']"
            class="ao-table-row tf"
          ></tr>

              <ng-container *ngIf="!isCredit && !isPaid">
              <tr
                mat-footer-row
                *matFooterRowDef="['aspacer', 'paidLabel', 'paid']"
                class="ao-table-row tf"
              ></tr>
              </ng-container>

            <ng-container *ngIf="!isCredit && !isPaid">
              <tr
                mat-footer-row
                *matFooterRowDef="['dspacer', 'dueLabel', 'due']"
                class="ao-table-row tf"
              ></tr>
            </ng-container>


            <!-- <ng-container *ngIf="isCredit && order.status !== 'CREDITED'">
              <tr
                mat-footer-row
                *matFooterRowDef="['spacer', 'diffLabel', 'diff']"
                class="ao-table-row tf"
              ></tr>
            </ng-container> -->


          </table>
        </div>
      </mat-card-content>
      <mat-card-actions class="mactions">
        <div class="d-flex justify-right w-100">
          <div
            *ngIf="editMode && !isPaid"
            class="fix-actions"
            [formGroup]="orderForm"
          >
            <div class="input">
              <mat-form-field floatLabel="never">
                <input
                  class="sm"
                  matInput
                  required
                  placeholder=""
                  type="text"
                  formControlName="initials"
                />
                <span matSuffix><mat-icon class="icon">gesture</mat-icon></span>
              </mat-form-field>
            </div>
          </div>
          <!-- <button
            *ngIf="!isPaid && !order.groupId"
            [disabled]="!orderForm.valid && editMode"
            class="btn icon dark"
            (click)="payOrder()"
          >
            <mat-icon matTooltip="Pay Invoice">attach_money</mat-icon>
          </button>
          <button
          *ngIf="!isPaid  && !order.groupId"
            [disabled]="!orderForm.valid && editMode"
            class="btn icon dark"
            (click)="payPrint()"
          >
            <mat-icon matTooltip="Pay & Print Invoice">receipt_long</mat-icon>
          </button>  -->
          <button
            *ngIf="isAwaitingCredit"
            [disabled]="!canSaveInvoice"
            class="btn icon secondary"
            (click)="markInvoiceCredited()"
          >
            <mat-icon matTooltip="Mark as Credited">payments</mat-icon>
          </button>
          <button
            *ngIf="!isPaid"
            [disabled]="!canSaveInvoice"
            class="btn icon secondary"
            (click)="saveOrder()"
          >
            <mat-icon matTooltip="Update Invoice">save</mat-icon>
          </button>
          <button
            *ngIf="!isPaid"
            [disabled]="!orderForm.valid"
            class="btn icon secondary"
            (click)="deleteInvoice()"
          >
            <mat-icon matTooltip="Delete Invoice">delete</mat-icon>
          </button>
          <app-invoice-log
            [order]="order"
            class="d-flex order-actions"
          ></app-invoice-log>
          <app-invoice-notes
            [order]="order"
            class="d-flex order-actions"
            (updateOrderEvent)="addNote($event)"
          ></app-invoice-notes>
        </div>
      </mat-card-actions>
    </mat-card>
  </div>
</div>
